module.exports = __webpack_public_path__ + "img/banner1.e25d2bda.png";